import { render, staticRenderFns } from "./UserTeam.vue?vue&type=template&id=2b04c662&scoped=true"
import script from "./UserTeam.vue?vue&type=script&lang=js"
export * from "./UserTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b04c662",
  null
  
)

export default component.exports